import { Node, mergeAttributes } from "@tiptap/core"

const SIZE_CLASSES = {
  small: "px-3 py-1 text-base",
  medium: "px-4 py-2 text-lg",
  large: "px-5 py-3 text-xl"
}

export const ButtonTemplateExtension = Node.create({
  name: "buttonTemplate",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      label: { default: "Click" },
      href: { default: "#" },
      size: { default: "small" }
    }
  },

  parseHTML() {
    return [{ tag: "button-template" }]
  },

  renderHTML({ HTMLAttributes }) {
    return ["button-template", mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("span")
      dom.contentEditable = "false"

      const btn = document.createElement("div")
      btn.setAttribute("data-href", node.attrs.href)
      btn.className = `inline-block bg-[var(--template-fc-button-backgroundColor)] text-[var(--template-fc-button-color)] rounded-[var(--template-fc-button-borderRadius)] font-bold ${SIZE_CLASSES[node.attrs.size] || SIZE_CLASSES.small}`
      btn.textContent = node.attrs.label
      dom.appendChild(btn)

      return { dom }
    }
  }
})
